import React, { Component } from 'react';

class Callback extends Component {

    componentDidMount() {
        this.props.auth.postLogin(this.props.location);
    }

    render() {
        return (
            <>Loading...</>
        );
    }
}

export default Callback;